var Backbone = require('backbone');

var Exception = Backbone.Model.extend({});

export default Exception;
